import JoditEditor from 'jodit-react';
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import TimePicker from 'react-time-picker';
import routes from "../../react_routes_enum";
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import { useState, useRef, useEffect } from "react";
import getImageUrls from "../../api/uploadImageOnS3";
import { useDispatch, useSelector } from "react-redux";
import LoaderIcon from "../../components/loader/Loader";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import UploadBox from "../../components/UploadBox/UploadBox";
import { removeEmptyKeys } from '../../utils/removeEmptyKeys';
import { getCoaching } from "../../redux/coaching/coachingSlice";
import { addBatch, updateBatchData } from "../../redux/batch/batchSlice";
import { getConfigDetails } from "../../redux/configurationDetails/configDetailsSlice";
import { Typography, Select, InputLabel, MenuItem, TextField, Button } from "@mui/material";
import 'react-clock/dist/Clock.css';
import 'react-time-picker/dist/TimePicker.css';

const useStyles = makeStyles( theme => ({
    topHeading: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    topHeader: {
        marginBottom: 24,
        fontSize: '34px',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    formInputLabel:{
        color: '#000 !important',
        fontSize: '18px !important',
        marginBottom: '4px',
        fontWeight: 'bold !important'
    },
    addMore: {
        background: '#F69220 !important',
        marginTop: '12px !important',
        color: '#FFF !important',
        textTransform: 'capitalize !important',
        borderRadius: '4px !important',
        "&:hover":{
            background: '#F69220',
        }
    },
    marginBot24: {
        marginBottom: '24px'
    },
}))

let formInfo = {
    name: "",
    image: "",
    faculty: [{
        name: "",
        image: "",
        description: "",
        qualification: ""
    }],
    category: "",
    language: "",
    for_what: "",
    study_mode: "",
    coaching_id: "",
    description: "",
    timing: "10:00 AM",
    batch_feature: [{
        name: "",
        price: 0,
        discount: 0,
        keyPoints: []
    }],
    end_date: new Date().toISOString().split("T")[0],
    start_date: new Date().toISOString().split("T")[0]
}

const BatchForm = (props) => {
    const editor = useRef(null);
    const classes = useStyles();
    const naviagte = useNavigate();
    const dispatch = useDispatch();

    const [forWhat, setForWhat] = useState([]);
    const [errors, setErrors] = useState(false);
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState([]);
    const [btnLoader, setBtnLoader] = useState(false);
    const [loadingIndex, setLoadingIndex] = useState(-1);
    const [featureKeyPoints, setFeatureKeyPoints] = useState("");
    const [formInformation, setFormInformation] = useState(formInfo);

    const { coachingData } = useSelector((state) => state.coaching);
    const { batchById } = useSelector((state) => state.batch);

    useEffect(() => {
        dispatch(getCoaching({ limit: 100, offset: 0, request_status: "accepted" }));
        if(props.type === "Edit"){
            batchById && getForWhatData(batchById?.coaching_id);
            batchById && setFormInformation({
                name: batchById?.name || "",
                image: batchById?.image || "",
                timing: batchById?.timing || "",
                faculty: batchById?.faculty || [],
                for_what: batchById?.for_what || "",
                language: batchById?.language || "",
                category: batchById?.category || "",
                study_mode: batchById?.study_mode || "",
                coaching_id: batchById?.coaching_id || "",
                description: batchById?.description || "",
                batch_feature: batchById?.batch_feature || [],
                end_date: new Date(batchById?.end_date).toISOString().split("T")[0] || new Date().toISOString().split("T")[0],
                start_date: new Date(batchById?.start_date).toISOString().split("T")[0] || new Date().toISOString().split("T")[0]
            });
        }
    }, [props.type])

    useEffect(() => {
        const res = dispatch(getConfigDetails());
        res.then((r) => {
            if(r?.payload?.data){
                r?.payload?.data?.map((item) => {
                    if(item.configuration_type === "coaching_category"){
                        setCategory(item?.data)
                    }
                })
            }
        })
    }, []);

    const handleChange = (event) => {
        event.target.name === 'name' && setFormInformation({...formInformation, name: event.target.value});
        event.target.name === "category" && setFormInformation({...formInformation, category: event.target.value });
        event.target.name === "language" && setFormInformation({...formInformation, language: event.target.value });
        event.target.name === "study_mode" && setFormInformation({...formInformation, study_mode: event.target.value });
        event.target.name === "for_what" && setFormInformation({...formInformation, for_what: event.target.value });
        event.target.name === "start_date" && setFormInformation({...formInformation, start_date: event.target.value });
        event.target.name === "end_date" && setFormInformation({...formInformation, end_date: event.target.value });
        event.target.name === "start_time" && setFormInformation({...formInformation, timing: event.target.value });
        if(event.target.name === "coaching_id"){
            getForWhatData(event.target.value);
            setFormInformation({...formInformation, coaching_id: event.target.value });
        }
    };

    const getForWhatData = (coachingId) => {
        const selectedCoaching = coachingData?.filter((item) => item._id === coachingId);
        (selectedCoaching && selectedCoaching?.length > 0) && 
            setForWhat(selectedCoaching[0]?.course_tought);
    }

    const onTimeChange = (value) => setFormInformation({...formInformation, timing: value });
    const textEditor = (text) => setFormInformation({...formInformation, description: text});
    const handleImageUploads = (name, value) => setFormInformation({...formInformation, image: value});

    const validate = () => {
        const status = {isValid: true, message: ""};
        if(!formInformation?.name || formInformation?.name === ""){
            status.isValid = false;
            status.message = "Batch Name Required";
            return status;
        }
        if(!formInformation?.coaching_id || formInformation?.coaching_id === ""){
            status.isValid = false;
            status.message = "Coaching Required";
            return status;
        }
        if(!formInformation?.for_what || formInformation?.for_what === ""){
            status.isValid = false;
            status.message = "For What Required";
            return status;
        }
        if(!formInformation?.study_mode || formInformation?.study_mode === ""){
            status.isValid = false;
            status.message = "Study Mode Required";
            return status;
        }
        if(formInformation?.start_date >= formInformation?.end_date){
            status.isValid = false;
            status.message = "End Date Must Be Greater";
            return status;
        }
        if(!formInformation?.timing || formInformation?.timing === ""){
            status.isValid = false;
            status.message = "Batch Time Required";
            return status;
        }
        if(!formInformation?.language || formInformation?.language === ""){
            status.isValid = false;
            status.message = "Language Required";
            return status;
        }
        if(!formInformation?.batch_feature || formInformation?.batch_feature?.length === 0){
            status.isValid = false;
            status.message = "Atleast 1 Batch Feature Required";
            return status;
        }
        if(formInformation?.batch_feature?.length > 0){
            formInformation?.batch_feature?.map((item) => {
                if(item?.name === ""){
                    status.isValid = false;
                    status.message = "Feature Name Required";
                    return status;
                }
                if(item?.price === 0){
                    status.isValid = false;
                    status.message = "Feature Price Required";
                    return status;
                }
                if(item?.keyPoints?.length === 0){
                    status.isValid = false;
                    status.message = "Feature Keypoints Required";
                    return status;
                }
            })
            
            return status;
        }
        return status;
    }

    const submit = () => {
        const status = validate();
        if(status.isValid){
            const body = removeEmptyKeys(formInformation);
            setBtnLoader(true);
            const res = props.type === "Add" ? 
                dispatch(addBatch(body)) : 
                dispatch(updateBatchData({
                    body,
                    id: batchById._id,
                }))
            res?.then((r) => {
                setBtnLoader(false);
                if(r.payload.statusCode === 200){
                    toast.success(r.payload.message);
                    naviagte(routes.BATCHES);
                    return;
                }
                toast.error(r.payload.message);
            })
            return;
        }
        toast.error(status.message);
    }

    const addMoreFeature = (type, data) => {
        if(type === "Feature"){
            let array = [...data];
            array.push({
                name: "",
                price: 0,
                discount: 0,
                keyPoints: []
            });
            setFormInformation({...formInformation, batch_feature: [...array] });
            return;
        }
        if(type === "Faculty"){
            let array = [...data];
            array.push({
                name: "",
                image: "",
                description: "",
                qualification: ""
            });
            setFormInformation({...formInformation, faculty: [...array] });
        }
    }

    const handleRemove = (type, data, index) => {
        if(type === "Feature"){
            let array = [...data];
            array.splice(index, 1);
            setFormInformation({...formInformation, batch_feature: [...array] });
            return;
        }
        if(type === "Faculty"){
            let array = [...data];
            array.splice(index, 1);
            setFormInformation({...formInformation, faculty: [...array] });
        }
    }

    const handleFeatureChange = (e) => {
        let array = [...formInformation?.batch_feature];
        array = array.map((element, ind) => {
            return {
                ...element,
                ...(e.target.name === `name_${ind}` && {name: e.target.value}),
                ...(e.target.name === `price_${ind}` && {price: e.target.value}),
                // ...(e.target.name === `studymode_${ind}` && {teaching_mode: e.target.value}),
                // ...(e.target.name === `duration_${ind}` && {duration: e.target.value}),
                ...(e.target.name === `discount_${ind}` && {discount: e.target.value}),
                // ...(e.target.name === `min_qualification_${ind}` && {min_qualification: e.target.value}),
            }
        })
        setFormInformation({
            ...formInformation,
            batch_feature: [...array]
        });
    }

    const handleFeatureKeyDown = (event) => {
        if (event.key === "Enter") {
            handleKeyPointChange(event);
            setFeatureKeyPoints("");
        }
    }

    const handleKeyPointChange = (e) => {
        let array = [...formInformation?.batch_feature];
        array = array.map((element, ind) => {
            let arrayData = [];
            if(ind === Number(e.target.name.split("_")[2])){
                arrayData = element?.keyPoints;
                arrayData = [...arrayData, e.target.value];
            }
            return {
                ...element,
                ...(e.target.name === `feature_keypoints_${ind}` && {keyPoints: [...arrayData]})
            }
        })
        setFormInformation({
            ...formInformation,
            batch_feature: [...array]
        });
    }

    const removeNestedItem = (mIndex, index, item) => {
        let array = [...formInformation?.batch_feature];
        let points = [...item.keyPoints];
        points.splice(index, 1);
        array = array.map((element, ind) => {
            return {
                ...element,
                ...(ind === mIndex && {keyPoints: [...points]})
            }
        })
        setFormInformation({
            ...formInformation,
            batch_feature: [...array]
        });
    }

    const uploadImage = async (e) => {
        if(e.target.files[0]?.type !== "image/png" &&
            e.target.files[0]?.type !== "image/jpeg"){
            toast.error("Invalid file type");
            return "";
        }
        if(e.target.files[0]?.size > 1049000){
            toast.error("Image size must be less than 1MB");
            return "";
        }
        setLoadingIndex(Number(e.target.name.split("_")[1]));
        const response = await getImageUrls({
            image: e.target.files[0],
            setLoading,
            setErrors,
        });
        setLoadingIndex(-1);
        return response?.data?.urls[0];
    }

    const handleFacultyChange = async(e) => {
        let value = "";
        let array = [...formInformation?.faculty];
        if(e.target.name.includes("file")){
            value = await uploadImage(e);
        }
        array = array.map((element, ind) => {
            return {
                ...element,
                ...(e.target.name === `file_${ind}` && {image: value}),
                ...(e.target.name === `name_${ind}` && {name: e.target.value}),
                ...(e.target.name === `description_${ind}` && {description: e.target.value}),
                ...(e.target.name === `qualification_${ind}` && {qualification: e.target.value})
            }
        })
        setFormInformation({
            ...formInformation,
            faculty: [...array]
        });
    }

    return (
        <div style={{padding: '12px'}}>
            <Typography
                variant="h2"
                component="h2"
                className={classes.topHeader}
            >
                {props.type === "Add" && "Add New Batch"}
                {props.type === "Edit" && "Edit Batch"}
            </Typography>
            <div className={classes.marginBot24}>
                <div style={{ display: 'flex' }}>
                    <div
                        style={{
                            width: '100%',
                            marginRight: '12px',
                            position: 'relative',
                        }}
                    >
                        <InputLabel className={classes.formInputLabel}>
                            Batch Name
                        </InputLabel>
                        <TextField
                            name="name"
                            type="text"
                            variant="outlined"
                            sx={{
                                width: '100%',
                                height: '62px'
                            }}
                            onChange={handleChange}
                            value={formInformation?.name}
                        />
                    </div>
                    <div style={{ width: '100%' }}>
                        <InputLabel className={classes.formInputLabel}>
                            Select Category
                        </InputLabel>
                        <Select
                            sx={{
                                width: '100%',
                                border: 'none',
                                height: '56px',
                                marginRight: '12px',
                                position: 'relative'
                            }}
                            name="category"
                            onChange={handleChange}
                            className="select-class"
                            value={formInformation?.category}
                        >
                            {(category && category?.length > 0) && 
                                category.map((item, index) => (
                                <MenuItem
                                    key={index}
                                    value={item?.cat}
                                >
                                    {item?.cat}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    
                </div>
            </div>
            <div className={classes.marginBot24}>
                <div style={{ display: 'flex' }}>
                    <div
                        style={{ 
                            width: '100%',
                            marginRight: '12px',
                            position: 'relative', 
                        }}
                    >
                        <InputLabel className={classes.formInputLabel}>
                            Select Coaching
                        </InputLabel>
                        <Select
                            sx={{
                                width: '100%',
                                border: 'none',
                                height: '56px',
                                marginRight: '12px',
                                position: 'relative'
                            }}
                            name="coaching_id"
                            onChange={handleChange}
                            className="select-class"
                            value={formInformation?.coaching_id}
                        >
                            {coachingData && coachingData.map((item, index) => (
                                <MenuItem
                                    key={index}
                                    value={item?._id}
                                >
                                    {item?.coaching_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div style={{ width: '100%'}}>
                        <InputLabel className={classes.formInputLabel}>
                            For What
                        </InputLabel>
                        <Select
                            sx={{
                                width: '100%',
                                border: 'none',
                                height: '56px',
                                marginRight: '12px',
                                position: 'relative'
                            }}
                            name="for_what"
                            onChange={handleChange}
                            className="select-class"
                            value={formInformation?.for_what}
                        >
                            {forWhat && forWhat.map((item, index) => (
                                <MenuItem
                                    key={index}
                                    value={item}
                                >
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    
                </div>
            </div>
            <div className={classes.marginBot24}>
                <div style={{ display: 'flex' }}>
                    <div
                        style={{
                            width: '100%',
                            marginRight: '12px',
                            position: 'relative',
                        }}
                    >
                        <InputLabel className={classes.formInputLabel}>
                            Start Date
                        </InputLabel>
                        <TextField
                            type="date"
                            variant="outlined"
                            sx={{
                                width: '100%',
                                height: '62px'
                            }}
                            name="start_date"
                            onChange={handleChange}
                            value={formInformation?.start_date}
                            inputProps={{
                                min: new Date().toISOString().split("T")[0]   // Set today's date as max
                            }}
                        />
                    </div>
                    <div style={{ width: '100%' }}>
                        <InputLabel className={classes.formInputLabel}>
                            End Date
                        </InputLabel>
                        <TextField
                            type="date"
                            variant="outlined"
                            sx={{
                                width: '100%',
                                height: '62px'
                            }}
                            name="end_date"
                            onChange={handleChange}
                            value={formInformation?.end_date}
                            inputProps={{
                                min: new Date().toISOString().split("T")[0]   // Set today's date as max
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className={classes.marginBot24}>
                <div style={{ display: 'flex' }}>
                    <div
                        style={{
                            width: '100%',
                            marginRight: '12px',
                            position: 'relative',
                        }}
                        className='time-picker'
                    >
                        <InputLabel className={classes.formInputLabel}>
                            Start Time
                        </InputLabel>
                        <TimePicker
                            locale="en-US"
                            clearIcon={null}
                            clockIcon={true}
                            format="HH:mm"
                            disableClock
                            // amPmAriaLabel="Select AM/PM"
                            onChange={(value) => onTimeChange(value)}
                            value={formInformation?.timing}
                        />
                        <div className='clock-icon'>
                            <AccessTimeIcon sx={{fontSize: '20px'}} />
                        </div>
                    </div>
                    <div style={{ width: '100%' }}>
                        <InputLabel className={classes.formInputLabel}>
                            Language
                        </InputLabel>
                        <TextField
                            type="text"
                            name="language"
                            variant="outlined"
                            sx={{
                                width: '100%',
                                height: '62px'
                            }}
                            onChange={handleChange}
                            value={formInformation?.language}
                        />
                    </div>
                </div>
            </div>
            <div className={classes.marginBot24}>
                <div style={{display: 'flex'}}>
                    <div
                        style={{ 
                            width: '100%',
                            marginRight: '12px',
                            position: 'relative',
                        }}
                    >
                        <InputLabel className={classes.formInputLabel}>
                            Study Mode
                        </InputLabel>
                        <Select
                            sx={{
                                width: '100%',
                                border: 'none',
                                height: '56px',
                                marginRight: '12px',
                                position: 'relative'
                            }}
                            name="study_mode"
                            onChange={handleChange}
                            className="select-class"
                            value={formInformation?.study_mode}
                        >
                            <MenuItem value="Online">Online</MenuItem>
                            <MenuItem value="Offline">Offline</MenuItem>
                            <MenuItem value="Live Classes">Live Classes</MenuItem>
                            <MenuItem value="Crash Courses">Crash Courses</MenuItem>
                            <MenuItem value="Certification Courses">Certification Courses</MenuItem>
                        </Select>
                    </div>
                    <div style={{width: '100%'}}></div>
                </div>
            </div>
            <div style={{marginBottom: "24px"}}>
                <InputLabel className={classes.formInputLabel}>
                    Batch Feature
                </InputLabel>
                {formInformation?.batch_feature?.map((item, index) => (
                    <div
                        key={index} 
                        style={{
                            padding: "8px",
                            marginBottom: "8px",
                            borderRadius: "4px",
                            border: "1px solid black"
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <InputLabel className={classes.formInputLabel}>
                                Feature {index + 1}
                            </InputLabel>
                            <Button
                                type="button"
                                onClick={() => handleRemove("Feature", formInformation?.batch_feature, index)}
                            >
                                <CloseIcon />
                            </Button>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div style={{width: '49%'}}>
                                <InputLabel className={classes.formInputLabel}>
                                    Name
                                </InputLabel>
                                <TextField
                                    type="text"
                                    name={"name_"+index}
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    onChange={handleFeatureChange}
                                    value={item?.name}
                                />
                            </div>
                            <div style={{width: '49%'}}>
                                <InputLabel className={classes.formInputLabel}>
                                    Price
                                </InputLabel>
                                <TextField
                                    type="text"
                                    value={item?.price}
                                    name={"price_"+index}
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    onChange={handleFeatureChange}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div style={{width: '49%'}}>
                                <InputLabel className={classes.formInputLabel}>
                                    Requirements&nbsp;
                                    <span className="optional-text">
                                        ( Press enter to add )
                                    </span>
                                </InputLabel>
                                <TextField
                                    type="text"
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    value={featureKeyPoints}
                                    name={"feature_keypoints_"+index}
                                    onKeyDown={(e) => handleFeatureKeyDown(e)}
                                    onChange={(e) => setFeatureKeyPoints(e.target.value)}
                                />
                            </div>
                            <div style={{width: '49%'}}>
                                <InputLabel className={classes.formInputLabel}>
                                    Discount
                                </InputLabel>
                                <TextField
                                    type="text"
                                    value={item?.discount}
                                    name={"discount_"+index}
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    onChange={handleFeatureChange}
                                />
                            </div>
                        </div>
                        {item?.keyPoints?.map((itm, ind) => (
                            <div
                                key={ind}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    {ind+1}.&nbsp;
                                    <p style={{margin: 0}}>
                                        {itm}
                                    </p>
                                </div>
                                <Button
                                    type="button"
                                    onClick={() => removeNestedItem(index, ind, item)}
                                >
                                    <CloseIcon />
                                </Button>
                            </div>
                        ))}
                    </div>
                ))}
                <Button
                    type="button"
                    className={classes.addMore}
                    onClick={() => addMoreFeature("Feature", formInformation?.batch_feature)}
                >
                    Add More
                </Button>
            </div>
            <div style={{marginBottom: "24px"}}>
                <InputLabel className={classes.formInputLabel}>
                    Faculty Details
                </InputLabel>
                {formInformation?.faculty?.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            padding: "8px",
                            marginBottom: "8px",
                            borderRadius: "4px",
                            border: "1px solid black"
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <InputLabel className={classes.formInputLabel}>
                                Faculty {index + 1}
                            </InputLabel>
                            <Button
                                type="button"
                                onClick={() => handleRemove("Faculty", formInformation?.faculty, index)}
                            >
                                <CloseIcon />
                            </Button>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div style={{width: '24%'}}>
                                <InputLabel className={classes.formInputLabel}>
                                    Name
                                </InputLabel>
                                <TextField
                                    type="text"
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    value={item?.name}
                                    name={"name_"+index}
                                    onChange={handleFacultyChange}
                                />
                            </div>
                            <div style={{width: '24%'}}>
                                <InputLabel className={classes.formInputLabel}>
                                    Highest Qualification
                                </InputLabel>
                                <TextField
                                    type="text"
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    value={item?.qualification}
                                    name={"qualification_"+index}
                                    onChange={handleFacultyChange}
                                />
                            </div>
                            <div style={{width: '24%'}}>
                                <InputLabel className={classes.formInputLabel}>
                                    Description
                                </InputLabel>
                                <TextField
                                    type="text"
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    value={item?.description}
                                    name={"description_"+index}
                                    onChange={handleFacultyChange}
                                />
                            </div>
                            <div style={{width: '24%'}}>
                                <InputLabel className={classes.formInputLabel}>
                                    Image
                                </InputLabel>
                                {(loading && loadingIndex === index) ? 
                                    <LoaderIcon/> : 
                                    <input
                                        type="file"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        name={"file_"+index}
                                        onChange={handleFacultyChange}
                                    />
                                }
                                {item?.image && 
                                    <p
                                        style={{
                                            marginTop: '4px',
                                            fontSize: '14px'
                                        }}
                                    >
                                        {item?.image?.split("-")[3]}
                                    </p>
                                }
                            </div>
                        </div>
                    </div>
                ))}
                <Button
                    type="button"
                    className={classes.addMore}
                    onClick={() => addMoreFeature("Faculty", formInformation?.faculty)}
                >
                    Add More
                </Button>
            </div>
            <div>
                <InputLabel className={classes.formInputLabel}>
                    Description <span className="optional-text-style">(Optional)</span>
                </InputLabel>
                <div style={{width: '100%', marginBottom: '24px'}}>
                    <JoditEditor 
                        ref={editor}
                        value={formInformation?.description}
                        onChange={(value) => textEditor(value)}
                    />
                </div>
            </div>
            <div className={classes.marginBot24}>
                <InputLabel className={classes.formInputLabel}>
                    Batch Image <span className="optional-text-style">(Optional)</span>
                </InputLabel>
                <div style={{ margin: '8px 24px 0 20px' }}>
                    <UploadBox
                        name="logo-upload"
                        value={formInformation?.image}
                        handleUpload={(name, value) => handleImageUploads(name, value)}
                    />
                </div>
            </div>
            <Button
                sx={{
                    width: '100%',
                    marginBottom: '12px',
                    backgroundColor: 'var(--primary-color)',
                    '&:hover': { backgroundColor: 'var(--primary-color)' }
                }}
                variant="contained"
                disabled={btnLoader}
                onClick={submit}
            >
                {btnLoader ? <LoaderIcon />  : (props.type === 'Edit' ? 'Update' : 'Submit') }
            </Button>
        </div>
    )
}
export default BatchForm;